// import { WhatsApp } from '../../channel/whatsapp';
import { Accounts as _Accounts } from './accounts';
import { Templates as _Templates } from './templates';
import { Stats as _Stats } from './stats';

/**
 * @deprecated Use WhatsApp.Accounts.GetFeaturesResponse instead.
 */
export type WhatsAppChannelGetFeaturesResponse = _Accounts.GetFeaturesResponse;

/**
 * @deprecated Use WhatsApp.Accounts.GetPhoneInfoResponse instead.
 */
export type WhatsAppChannelGetPhoneInfoResponse = _Accounts.GetPhoneInfoResponse;

export { TemplateCreateBody, TemplatePatchBody, TemplateLocalizationCreateBody, TemplateLocalizationPatchBody } from './templates';

export namespace WhatsApp {

    export import Accounts = _Accounts;

    export import Stats = _Stats;

    export import Templates = _Templates;

}
